import store from '../../store'
import find from 'lodash/find'
import {createMeetingProjectConnectionRequest} from '../../actions/meetings'

export function createMeetingProjectConnection(meetingId,projectId) {	
	store.dispatch(createMeetingProjectConnectionRequest(meetingId,projectId))
}

